import React, { useContext } from 'react';

import { QuizzicalContext, ScreenModes } from '../Context/QuizzicalContext';
import PresentationRoot from '../Controls/Presentation/PresentationRoot';

export default function PresentationScreen(props) {
    const state = useContext(QuizzicalContext);

    return (<PresentationRoot state={state} />);
}